import { render, staticRenderFns } from "./wuzangxiangyin.vue?vue&type=template&id=d42dd8f6&scoped=true&"
import script from "./wuzangxiangyin.vue?vue&type=script&lang=ts&"
export * from "./wuzangxiangyin.vue?vue&type=script&lang=ts&"
import style0 from "./wuzangxiangyin.vue?vue&type=style&index=0&id=d42dd8f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42dd8f6",
  null
  
)

export default component.exports